<template>
  <div class="article-block d-flex">
    <div class="article-list">
      <div class="module j-flex">
        <div class="fs-xl module-title">{{ title1 }}</div>
        <div class="fs-xs more" @click="titleOneMore">更多>></div>
      </div>
      <li
        class="list-each j-flex fs-sm"
        v-for="item in leftData"
        :key="item.id"
        @click="homepageToDeatil1(item)"
      >
        <div class="d-flex title">
          <div class="circle"></div>
          <div class="overflow" style="width: calc(100% - 10px)">
            {{ item.title }}
          </div>
        </div>
        <div class="date">{{ item.publishDate | formateDate }}</div>
      </li>
    </div>

    <div class="article-list" style="margin-left: 24px">
      <div class="module j-flex">
        <div class="fs-xl module-title">{{ title2 }}</div>
        <div class="fs-xs more" @click="titleTwoMore">更多>></div>
      </div>
      <li
        class="list-each j-flex fs-sm"
        v-for="item in rightData"
        :key="item.id"
        @click="homepageToDeatil2(item)"
      >
        <div class="d-flex title">
          <div class="circle"></div>
          <div class="overflow" style="width: calc(100% - 10px)">
            {{ item.title }}
          </div>
        </div>
        <div class="date">{{ item.publishDate | formateDate }}</div>
      </li>
    </div>
  </div>
</template>
<script>
import { formateDate } from '../../../assets/js/date'
export default {
  props: ['title1', 'title2', 'leftData', 'rightData'],
  data() {
    return {
      article: [
        {
          id: 0,
          title: '校领导除夕看望慰问留校师生员工和防疫工作专班',
          date: '01-14',
        },
        {
          id: 1,
          title: '校领导除夕看望慰问留校师生员工和防疫工作专班',
          date: '01-14',
        },
        {
          id: 2,
          title: '校领导除夕看望慰问留校师生员工和防疫工作专班',
          date: '01-14',
        },
        {
          id: 3,
          title: '校领导除夕看望慰问留校师生员工和防疫工作专班',
          date: '01-14',
        },
        {
          id: 4,
          title: '校领导除夕看望慰问留校师生员工和防疫工作专班',
          date: '01-14',
        },
        {
          id: 5,
          title: '校领导除夕看望慰问留校师生员工和防疫工作专班',
          date: '01-14',
        },
        {
          id: 6,
          title: '校领导除夕看望慰问留校师生员工和防疫工作专班',
          date: '01-14',
        },
        {
          id: 7,
          title: '校领导除夕看望慰问留校师生员工和防疫工作专班',
          date: '01-14',
        },
      ],
      nav: [
        { id: 0, title: '国务院', href: '/document' },
        { id: 1, title: '教育部', href: '/document' },
        { id: 2, title: '教育厅', href: '/document' },
        { id: 3, title: '市教育局', href: '/document' },
        { id: 4, title: '学校', href: '/document' },
        { id: 5, title: '部门', href: '/document' },
      ],
      navGh: [
        { id: 0, title: '学校工会', href: '/union' },
        { id: 1, title: '部门工会', href: '/union' },
      ],
    }
  },
  filters: {
    formateDate(time) {
      let date = new Date(time)
      return formateDate(date, 'yyyy-MM-dd')
    },
  },
  methods: {
    homepageToDeatil1(item) {
      var currPath = '/'
      var oneName = ''
      var index = 0
      //   var twoName = ''
      if (this.title1 == '教学信息') {
        currPath = '/teaching'
        oneName = '体育教学'
        // twoName = '教学信息'
      } else if (this.title1 == '政策文件') {
        currPath = '/document'
        oneName = '政策文件'
        // twoName = '国务院'
        for (let i = 0; i < this.nav.length; i++) {
          if (item.category.name == this.nav[i].title) {
            index = i
          }
        }
      }
      this.$router.push({
        path: '/article',
        query: {
          one: oneName,
          two: item.category.name,
          three: '',
          path: currPath,
          keepalive: index,
          //   keepchild: this.listChildIndex,
          articleId: item.uuid,
        },
      })
    },
    homepageToDeatil2(item) {
      var currPath = '/'
      var oneName = ''
      var index = 0
      //   var twoName = ''
      if (this.title2 == '科研信息') {
        currPath = '/research'
        oneName = '科学研究'
        // twoName = '科研信息'
      } else if (this.title2 == '工会工作') {
        currPath = '/union'
        oneName = '工会工作'
        // twoName = '学校工会'
        for (let i = 0; i < this.navGh.length; i++) {
          if (item.category.name == this.navGh[i].title) {
            index = i
          }
        }
      }
      this.$router.push({
        path: '/article',
        query: {
          one: oneName,
          two: item.category.name,
          three: '',
          path: currPath,
          keepalive: index,
          //   keepchild: this.listChildIndex,
          articleId: item.uuid,
        },
      })
    },
    titleOneMore() {
      if (this.title1 == '教学信息') {
        this.$router.push({
          path: '/teaching',
          query: {
            one: '体育教学',
            two: '教学信息',
            three: '',
            //   path: this.currPath,
            keepalive: 0,
            //   keepchild: this.listChildIndex,
            //   articleId: item.id,
          },
        })
      } else if (this.title1 == '政策文件') {
        this.$router.push({
          path: '/document',
          query: {
            one: '政策文件',
            two: '国务院',
            three: '',
            //   path: this.currPath,
            keepalive: 0,
            //   keepchild: this.listChildIndex,
            //   articleId: item.id,
          },
        })
      }
    },
    titleTwoMore() {
      if (this.title2 == '工会工作') {
        this.$router.push({
          path: '/union',
          query: {
            one: '工会工作',
            two: '学校工会',
            three: '',
            //   path: this.currPath,
            keepalive: 0,
            //   keepchild: this.listChildIndex,
            //   articleId: item.id,
          },
        })
      } else if (this.title2 == '科研信息') {
        this.$router.push({
          path: '/research',
          query: {
            one: '科学研究',
            two: '科研信息',
            three: '',
            //   path: this.currPath,
            keepalive: 0,
            //   keepchild: this.listChildIndex,
            //   articleId: item.id,
          },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/main.scss';
.article-block {
  width: 1052px;
  height: 326px;
  background-color: $white;
  padding: 24px;
  margin-top: 24px;
}
.module {
  //   border-bottom: 1px dashed #000000;
  background: url('../../../assets/img/dot.jpg');
  background-repeat: repeat-x;
  background-position: bottom;
  line-height: 34px;
  padding-bottom: 8px;
  color: $titleFont;
}
.more {
  color: $lightFont;
  cursor: pointer;
  &:hover {
    color: #007a4d;
  }
}
.article-list {
  width: 514px;
  height: 326px;
  //   margin-left: 24px;
}
.circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $mainFont;
  margin-right: 8px;
  margin-left: 8px;
}
.list-each {
  list-style: none;
  color: $mainFont;
  line-height: 36px;
  //   border-bottom: 1px dashed $mainFont;
  background: url('../../../assets/img/dot.jpg');
  background-repeat: repeat-x;
  background-position: bottom;
  cursor: pointer;
  &:hover {
    color: $darkGrenn;
    .circle {
      background-color: $darkGrenn;
    }
  }
  &:hover .date {
    color: $darkGrenn;
  }
}
.title {
  align-items: center;
  width: calc(100% - 100px);
}
.module-title {
  font-weight: 600;
}
.date {
  color: $lightFont;
  white-space: nowrap;
  width: 100px;
  text-align: right;
}
</style>
